"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var action_1 = require("../action");
var schedule = function (scheduler, schedulee) { return action_1.default(function (_a) {
    var update = _a.update, complete = _a.complete;
    var latest;
    var schedulerSub = scheduler.start({
        update: function () { return latest !== undefined && update(latest); },
        complete: complete
    });
    var scheduleeSub = schedulee.start({
        update: function (v) { return latest = v; },
        complete: complete
    });
    return {
        stop: function () {
            schedulerSub.stop();
            scheduleeSub.stop();
        }
    };
}); };
exports.default = schedule;
//# sourceMappingURL=schedule.js.map


//////////////////
// WEBPACK FOOTER
// ./~/popmotion/compositors/schedule.js
// module id = 95
// module chunks = 112359326995148 213534597649335 241203398517478